var image_viewer_rtlignore_default = {
  "fontElementMap": "vSgJU",
  "imageContainer": "LyA8p",
  "expandButton": "YtuHp",
  "expandIcon": "TuJhb",
  "pointer": "Clrsk",
  "imageWrapper": "_0ImwN",
  "imageRatio": "qBeG1",
  "image": "exAgx",
  "imageOverlay": "MvXg-",
  "imagePreload": "v22A6",
  "imageHighres": "H78LJ",
  "onlyHighRes": "ExJYw",
  "image_loading": "_4hKZl"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
